import type { ListFaxesResponse } from '@compass/client/types/fax';
import { faxService as generatedFaxService } from '@services/api';

/**
 * Convenience wrapper over the generated `FaxService`.
 *
 * The HTTP call itself is now the generated `faxService.listFaxes` (BV-1874); this module
 * only adapts the camelCase context object its callers already pass.
 */

export interface CaseRecordContext {
  organizationId: string;
  programId: string;
  caseRecordId: string;
}

export const faxService = {
  /**
   * Get all faxes for a case record.
   */
  async getFaxes(context: CaseRecordContext): Promise<ListFaxesResponse> {
    const { organizationId, programId, caseRecordId } = context;

    return generatedFaxService.listFaxes({
      organization_id: organizationId,
      program_id: programId,
      case_record_id: caseRecordId,
    });
  },
};
